import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import { CartBrowsingCriteria } from '@insurancemenu/imenu-components-lib/dist/types/productCardsTypings';
import { EnrollmentStage } from 'types/enrollmentService';

export type ProposalExperience = 'SHELF' | 'FAVORITE' | 'CUSTOM' | 'RENEWAL_SHELF' | 'RENEWAL_CUSTOM';

export type RenewalActionType = 'ADD_BENEFIT' | 'RENEW_AS_IS' | 'CHANGE_PLAN' | 'CANCEL_COVERAGE';

export const RENEWAL_ACTIONS: RenewalActionType[] = ['ADD_BENEFIT', 'RENEW_AS_IS', 'CHANGE_PLAN', 'CANCEL_COVERAGE'];

export type RenewalActionDisabledReason =
  | 'EFFECTIVE_DATE_PASSED'
  | 'RETRO_QUOTING_PERIOD_PASSED'
  | 'NO_ADDITIONAL_BENEFITS_AVAILABLE';

export const RENEWAL_ACTION_DISABLED_REASON_LABEL: Record<RenewalActionDisabledReason, string> = {
  EFFECTIVE_DATE_PASSED: 'The effective date has passed',
  RETRO_QUOTING_PERIOD_PASSED: 'The retro-quoting period has passed',
  NO_ADDITIONAL_BENEFITS_AVAILABLE: 'No additional benefits are available to add',
};

export type RenewalActionMap = {
  action: RenewalActionType;
  disabledReason: RenewalActionDisabledReason | null;
  productLineIds: ProductLineId[];
  /** Tooltip copy for the Special Access tag. The tag is shown only when this is set. */
  accessLimitation?: string;
};

export type ProposalExperienceDisabledReasons = Partial<Record<ProposalExperience, string | null>>;

export type ProposalExperienceAccessLimitations = Partial<Record<ProposalExperience, string>>;

export const PROPOSAL_EXPERIENCE_DISABLED_REASONS = {
  ALL_PRODUCT_LINES_QUOTED: 'Unavailable because all product lines have already been quoted',
  COVERAGE_ALREADY_IN_FORCE: 'Unavailable because proposal may include coverage already in force',
};

export interface EffectiveDateConfigItem {
  value: string;
  label: string;
  stage: EnrollmentStage | null;
  isDisabled: boolean;
}

/** Fields the experience and favorite steps need to save. Sponsor stores add carrier extras on browsingCriteria. */
export interface ProposalExperiencePayload {
  proposalName: string;
  browsingCriteria: CartBrowsingCriteria;
}

/** Carrier catalog for the experience step. Returned from the page store so lists can depend on roles. */
export interface ProposalExperiencePolicy {
  /** Experiences shown when the effective date is not a renewal. */
  newBusinessExperiences: ProposalExperience[];
  /** Experiences shown when the effective date is a renewal. */
  renewalExperiences: ProposalExperience[];
  /**
   * Carrier-specific disable rules. When set, these replace the default reasons entirely.
   * Omit to keep the shared experience rules.
   */
  getExperienceDisabledReasons?(): ProposalExperienceDisabledReasons;
  /**
   * Tooltip copy for the Special Access tag, keyed by experience.
   * Omit, or return an empty map, when no experience needs a tag.
   */
  getExperienceAccessLimitations?(): ProposalExperienceAccessLimitations;
}
